"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stringifyStream = require("stream-to-string");
/**
 * A GraphQL-LD engine that is backed by Comunica.
 */


var QueryEngineComunicaSolid =
/*#__PURE__*/
function () {
  function QueryEngineComunicaSolid(context) {
    _classCallCheck(this, QueryEngineComunicaSolid);

    this.comunicaEngine = require('./comunica-engine');
    this.context = context;
  }

  _createClass(QueryEngineComunicaSolid, [{
    key: "query",
    value: function query(_query, options) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this.comunicaEngine;
                _context.next = 3;
                return this.comunicaEngine.query(_query, Object.assign({}, options, this.context));

              case 3:
                _context.t1 = _context.sent;
                _context.next = 6;
                return _context.t0.resultToString.call(_context.t0, _context.t1, 'application/sparql-results+json');

              case 6:
                _ref = _context.sent;
                data = _ref.data;
                _context.t2 = JSON;
                _context.next = 11;
                return stringifyStream(data);

              case 11:
                _context.t3 = _context.sent;
                return _context.abrupt("return", _context.t2.parse.call(_context.t2, _context.t3));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return QueryEngineComunicaSolid;
}();

exports.QueryEngineComunicaSolid = QueryEngineComunicaSolid;